if (!customElements.get('lazy-shop-pay-installments')) {
  customElements.define(
    'lazy-shop-pay-installments',
    class LazyShopPayInstallments extends HTMLElement {
      connectedCallback() {
        if (!this.onVariantInputChange) {
          this.onVariantInputChange = this.syncPaymentTermsVariant.bind(this);
        }
        this.productInfo = this.closest('product-info');
        this.productInfo?.addEventListener('change', this.onVariantInputChange);
        this.currentVariantId =
          Array.from(
            this.productInfo?.querySelectorAll(
              'form[id^="product-form-"] .product-variant-id[name="id"]',
            ) || [],
          ).find((input) => !this.contains(input))?.value || this.currentVariantId;

        if (this.dataset.started === 'true') return;
        this.dataset.started = 'true';

        const afterImageDelay = Number.parseInt(this.dataset.afterImageDelay || '600', 10);
        const start = () => {
          if (this.dataset.scheduled === 'true') return;
          this.dataset.scheduled = 'true';
          window.setTimeout(
            () => this.load(),
            Number.isFinite(afterImageDelay) ? afterImageDelay : 600,
          );
        };
        const startAfterPaint = () => {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(start);
          });
        };
        const heroImage = document.querySelector('.product__media img[fetchpriority="high"]');
        const startAfterDecode = () => {
          if (typeof heroImage?.decode !== 'function') {
            startAfterPaint();
            return;
          }

          heroImage.decode().then(startAfterPaint).catch(startAfterPaint);
        };

        if (heroImage?.complete && heroImage.naturalWidth > 0) {
          startAfterDecode();
        } else if (heroImage) {
          heroImage.addEventListener('load', startAfterDecode, { once: true });
          heroImage.addEventListener('error', startAfterPaint, { once: true });
        } else if (document.readyState === 'complete') {
          startAfterPaint();
        } else {
          window.addEventListener('load', startAfterPaint, { once: true });
        }
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onVariantInputChange);
      }

      syncPaymentTermsVariant(event) {
        const sourceInput = event.target;
        if (
          !(sourceInput instanceof HTMLInputElement) ||
          !sourceInput.matches('form[id^="product-form-"] .product-variant-id[name="id"]') ||
          this.contains(sourceInput)
        ) {
          return;
        }

        this.currentVariantId = sourceInput.value;
        this.updatePaymentTermsInput(this.currentVariantId);
      }

      updatePaymentTermsInput(variantId) {
        const paymentTermsInput = this.querySelector('input[name="id"]');
        if (!variantId || !paymentTermsInput || paymentTermsInput.value === variantId) return;

        paymentTermsInput.value = variantId;
        paymentTermsInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      async load() {
        if (!this.dataset.sectionUrl || this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';

        try {
          const response = await fetch(this.dataset.sectionUrl, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });
          if (!response.ok) throw new Error(`Shop Pay section request failed: ${response.status}`);

          const markup = await response.text();
          const parsed = new DOMParser().parseFromString(markup, 'text/html');
          const content = parsed.querySelector('[data-lazy-shop-pay-content]');
          if (!content) throw new Error('Shop Pay section content was not found');

          this.replaceChildren(...Array.from(content.childNodes));
          this.updatePaymentTermsInput(this.currentVariantId);
          await this.loadPaymentTerms();
        } catch (error) {
          this.remove();
        }
      }

      loadPaymentTerms() {
        if (customElements.get('shopify-payment-terms') || !this.dataset.loaderUrl) {
          return Promise.resolve();
        }

        const existing = Array.from(document.scripts).find((script) => script.src === this.dataset.loaderUrl);
        if (existing) {
          return new Promise((resolve) => {
            if (customElements.get('shopify-payment-terms')) {
              resolve();
              return;
            }
            existing.addEventListener('load', resolve, { once: true });
            existing.addEventListener('error', resolve, { once: true });
          });
        }

        return new Promise((resolve) => {
          const script = document.createElement('script');
          script.type = 'module';
          script.src = this.dataset.loaderUrl;
          script.onload = resolve;
          script.onerror = resolve;
          document.head.appendChild(script);
        });
      }
    },
  );
}
